/* eslint-disable  @typescript-eslint/no-explicit-any */
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ApiService, HttpParamsOptions } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { Config } from 'datatables.net';
import Swal from 'sweetalert2';
import { callStatusList } from '../../shared/constants';
import moment from 'moment';

@Component({
	selector: 'app-call-list',
	templateUrl: './call-list.component.html',
	styleUrl: './call-list.component.scss'
})
export class CallListComponent implements OnInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/call-list",
			name: "Call List"
		}
	];

	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	dtOptions: Config = {};
	dataList: any = [];
	showDeleteLoader: any = null;
	pagetitle = "Call List";
	pageLoading = false;
	UserModuleAccess: any = "Full";
	filters: any = {
		call_type: "call_missed_by_agent"
	};
	statusList = callStatusList;
	call_counts: any = {};

	constructor(private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, private http: HttpClient) { }

	ngOnInit(): void {
		this.initDatatable();
		this.getCallCounts();
	}

	initDatatable() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			searching: false,
			layout: {
				top: [],
				topStart: [],
				topEnd: [],
				bottomStart: [],
				bottomEnd: [],
				bottom: ['pageLength', 'info', 'paging']
			},
			ajax: (dataTablesParameters: any, callback) => {
				const data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length,
					call_type: this.filters.call_type
				}
				this.apiService.getCalls(data).subscribe({
					next: (response: any) => {
						this.dataList = response.data;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered,
							data: []
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	getCallCounts() {
		this.apiService.getCallCounts().subscribe({
			next: (data: any) => {
				this.call_counts = data;
			}
		})
	}

	selectType(type: string) {
		this.filters.call_type = type;
		this.refreshTable();
	}

	refreshTable() {
		this.datatableElement.dtInstance.then((dtInstance) => {
			dtInstance.draw();
		});
	}

	formatDateTime(ts: string) {
		const m = moment(ts);
		if (m.isValid()) {
			return m.format("DD-MM-YYYY HH:mm");
		} else {
			return ts;
		}
	}

	getIcon(call_type: string) {
		return this.statusList.find((s) => s.val === call_type)?.img2;
	}

	getType(call_type: string) {
		return this.statusList.find((s) => s.val === call_type)?.name1;
	}

	getSelectedClass(call_type: string) {
		if (call_type == this.filters.call_type) {
			return "selected";
		} else {
			return "";
		}
	}
}
